<template>
	<Teleport to="#header" v-if="$slots.header">
		<slot name="header"></slot>
	</Teleport>
	<Teleport to="#header" v-if="$slots.h1">
		<div class="py-4">
			<h1>
				<!-- {{ console.log($slots.h1) }} -->
				  <!-- {{ $attrs }} -->
				<slot name="h1"></slot>
			</h1>
		</div>
	</Teleport>
	<slot name="default" :class="$attrs.class"></slot>
</template>
